export default "__VITE_ASSET__DHvw8h49__"